export default {"src":"/_next/static/media/plusAdd.6d644f47.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};